import type { CamelCasedProperties, SnakeCasedProperties } from '~/types'

export function useToCamelCase(str: string): string {
  return str.replace(/([-_][a-z])/g, group => group.toUpperCase().replace('-', '').replace('_', ''))
}

export function useKeysToCamelCase<T>(obj: T): CamelCasedProperties<T> {
  if (Array.isArray(obj)) {
    return obj.map(v => useKeysToCamelCase(v)) as unknown as CamelCasedProperties<T>
  }
  else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce(
      (result, key) => ({
        ...result,
        [useToCamelCase(key)]: useKeysToCamelCase((obj as Record<string, unknown>)[key]),
      }),
      {} as CamelCasedProperties<T>,
    )
  }
  return obj as CamelCasedProperties<T>
}

export function useToSnakeCase(str: string): string {
  return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`)
}

export function useKeysToSnakeCase<T>(obj: T): SnakeCasedProperties<T> {
  if (Array.isArray(obj)) {
    return obj.map(v => useKeysToSnakeCase(v)) as unknown as SnakeCasedProperties<T>
  }
  else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce(
      (result, key) => ({
        ...result,
        [useToSnakeCase(key)]: useKeysToSnakeCase((obj as Record<string, unknown>)[key]),
      }),
      {} as SnakeCasedProperties<T>,
    )
  }
  return obj as SnakeCasedProperties<T>
}
